const fonts = {
  fontFamily: 'Open Sans',
  lineHeight: '32px',
  color: '#6A6A6A',
};

export const sxStyled = theme => ({
  root: {
    backgroundColor: '#FFFFFF',
    borderRadius: '0px 0px 8px 8px',
    padding: {
      xs: '21px 41px',
      sm: undefined,
    },
  },
  box: {
    borderBottom: '8px solid transparent',
    padding: '1.5rem',
    textAlign: { xs: 'center', sm: 'left' },
    cursor: 'pointer',
    '&:hover': {
      borderBottom: `8px solid ${theme.primary}`,
      '.boxTitle': { color: '#211915' },
      '.boxPrice': { color: '#211915', fontWeight: 400 },
    },
  },
  active: {
    '.boxPrice': { fontWeight: 600, color: '#000' },
    '.boxTitle': { color: '#000' },
    '.boxInfo': { color: '#000' },
  },
  boxTitle: {
    fontSize: '18px',
    fontWeight: 700,
    ...fonts,
    textAlign: 'center',
  },
  boxInfo: {
    fontSize: '14px',
    fontWeight: 400,
    ...fonts,
    textAlign: 'center',
    marginBottom: '-8px',
  },
  boxPrice: {
    fontSize: '24px',
    fontWeight: 300,
    ...fonts,
    textAlign: 'center',
  },
  divider: {
    alignSelf: 'center',
    backgroundColor: 'rgba(34, 34, 34, 0.2)',
    width: { xs: '72px', sm: 'auto' },
    marginTop: { xs: '24px', sm: 0 },
    height: { xs: '1px', sm: '100px' },
  },
});
